import { render, staticRenderFns } from "./Edit-Review.vue?vue&type=template&id=35f1eafc"
import script from "./Edit-Review.vue?vue&type=script&lang=js"
export * from "./Edit-Review.vue?vue&type=script&lang=js"
import style0 from "./Edit-Review.vue?vue&type=style&index=0&id=35f1eafc&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports